import React, { useState } from "react";
import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { Stack, Button } from "@mui/material";
import { isEmptyObject } from "helpers/formatObject";
import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function CreateUser({ refetch, title = "کاربر جدید" }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [create, { loading }] = useMutation(graph.create.query);

  const onSubmit = async ({ formData }) => {
    try {
      const {
        lastname,
        firstname,
        cellphone,
        birth_date,
        national_code,
        gender,
        user_category_id,
      } = formData;
      const { data, errors } = await create({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          type_id: "6",
          need_activation: 0,
          lastname,
          firstname,
          cellphone,
          birth_date,
          national_code,
          gender,
          user_category_id,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.create.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Button
        size="medium"
        color="secondary"
        variant="contained"
        onClick={onOpen}
      >
        {title}
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <MuiFormBuilder
              id="create"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={formData}
              onSubmit={onSubmit}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="create"
            variant="contained"
            disabled={loading}
          >
            تایید و ادامه
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
